import utils from '@/mixins/utils.js'

/**
 * Função para verificar pendências baseada nos alertas da TabelaCadastros.vue
 * @param {Object} item
 * @returns {string}
 */
function verificarPendencias(item) {
  const pendencias = []

  // Primeira consulta (a_pb)
  if (item.a_pb == null || item.a_pb == 0) {
    pendencias.push('Primeira consulta pré-natal')
  }

  // Consultas (b_pb)
  if (item.b_pb == null || item.b_pb == 0) {
    pendencias.push('Consultas pré-natal')
  }

  // Aferição PA (c_pb)
  if (item.c_pb == null || item.c_pb == 0) {
    pendencias.push('Aferição de PA')
  }

  // Peso e altura (d_pb)
  if (item.d_pb == null || item.d_pb == 0) {
    pendencias.push('Peso e altura')
  }

  // Visitas gestante (e_pb)
  if (item.e_pb == null || item.e_pb == 0) {
    pendencias.push('Visita ACS/TACS na Gestante')
  }

  // Vacinas (f_pb) - apenas se idade gestacional >= 20 semanas
  if (item.ig_atual >= 20 && (item.f_pb == null || item.f_pb == 0)) {
    pendencias.push('Vacina dTpa')
  }

  // Primeiro trimestre (g_pb)
  if (item.g_pb == null || item.g_pb == 0) {
    pendencias.push('Exames do 1º trimestre')
  }

  // Terceiro trimestre (h_pb) - apenas se trimestre >= 3
  if (item.trimestre >= 3 && (item.h_pb == null || item.h_pb == 0)) {
    pendencias.push('Exames do 3º trimestre')
  }

  // Consulta puerperal (i_pb) - apenas se não for gestante
  if (item.ainda_gestante != 1 && (item.i_pb == null || item.i_pb == 0)) {
    pendencias.push('Consulta puerperal')
  }

  // Visita puerpério (j_pb) - apenas se não for gestante
  if (item.ainda_gestante != 1 && (item.j_pb == null || item.j_pb == 0)) {
    pendencias.push('Visita ACS/TACS na puérpera')
  }

  // Avaliação odontológica (k_pb)
  if (item.k_pb == null || item.k_pb == 0) {
    pendencias.push('Atendimento odontológico')
  }

  return pendencias.length > 0 ? pendencias.join(', ') : ''
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  Microárea: 'micro_area',
  Pendências: {
    callback: (item) => {
      return verificarPendencias(item)
    },
  },
}

export const infoHtml = ``

export const optionsFilterBoasPraticasGestantes = [
  {
    label: 'Todas',
    value: null,
    key: 'todas',
    key_percentual: 'todas',
  },
  {
    label: 'Primeira consulta',
    value: 'a_pb',
    key: 'primeira-consulta',
    key_percentual: 'fai_1consulta',
  },
  {
    label: 'Consultas pré-natal',
    value: 'b_pb',
    key: 'consultas',
    key_percentual: 'fai',
  },
  {
    label: 'Aferição PA',
    value: 'c_pb',
    key: 'afericao-pa',
    key_percentual: 'pa',
  },
  {
    label: 'Peso e altura',
    value: 'd_pb',
    key: 'peso-altura',
    key_percentual: 'pes_alt',
  },
  {
    label: 'Visita ACS/TACS',
    value: 'e_pb',
    key: 'visitas',
    key_percentual: 'fvdt',
  },
  {
    label: 'Vacina dTpa',
    value: 'f_pb',
    key: 'vacinas',
    key_percentual: 'vac',
  },
  {
    label: 'Exames 1° trimestre',
    value: 'g_pb',
    key: 'primeiro-trimestre',
    key_percentual: 'enx_sol_aval_1trim',
  },
  {
    label: 'Exames 3° trimestre',
    value: 'h_pb',
    key: 'terceiro-trimestre',
    key_percentual: 'enx_sol_aval_3trim',
  },
  {
    label: 'Atendimento odontológico',
    value: 'k_pb',
    key: 'avaliacao-odonto',
    key_percentual: 'fao',
  },
]

export const optionsFilterBoasPraticasPuerperas = [
  {
    label: 'Todas',
    value: null,
    key: 'todas',
    key_percentual: 'todas',
  },
  {
    label: 'Primeira consulta',
    value: 'a_pb',
    key: 'primeira-consulta',
    key_percentual: 'fai_1consulta',
  },
  {
    label: 'Consultas pré-natal',
    value: 'b_pb',
    key: 'consultas',
    key_percentual: 'fai',
  },
  {
    label: 'Aferição PA',
    value: 'c_pb',
    key: 'afericao-pa',
    key_percentual: 'pa',
  },
  {
    label: 'Peso e altura',
    value: 'd_pb',
    key: 'peso-altura',
    key_percentual: 'pes_alt',
  },
  {
    label: 'Visita ACS/TACS Gestante',
    value: 'e_pb',
    key: 'visitas',
    key_percentual: 'fvdt',
  },
  {
    label: 'Vacina dTpa',
    value: 'f_pb',
    key: 'vacinas',
    key_percentual: 'vac',
  },
  {
    label: 'Exames 1° trimestre',
    value: 'g_pb',
    key: 'primeiro-trimestre',
    key_percentual: 'enx_sol_aval_1trim',
  },
  {
    label: 'Exames 3° trimestre',
    value: 'h_pb',
    key: 'terceiro-trimestre',
    key_percentual: 'enx_sol_aval_3trim',
  },
  {
    label: 'Consulta puerperal',
    value: 'i_pb',
    key: 'consulta-puerperal',
    key_percentual: 'fai_1consulta_puerperio',
  },
  {
    label: 'Visita ACS/TACS Puérpera',
    value: 'j_pb',
    key: 'visita-puerperio',
    key_percentual: 'fvdt_puerperio',
  },
  {
    label: 'Atendimento odontológico',
    value: 'k_pb',
    key: 'avaliacao-odonto',
    key_percentual: 'fao',
  },
]
